import { useMemo } from 'react';
import useBookingBill from '@/features/dashboard/bookingChanges/hooks/useBookingBill.ts';
import useGetOpenDraft from '@/features/dashboard/bookingChanges/hooks/useGetOpenDraft.ts';
import useChangePreview from '@/features/dashboard/bookingChanges/hooks/useChangePreview.ts';
import { bookingBillMapper } from '@/features/dashboard/bookingChanges/types/BookingBill.mapper.ts';
import { BookingBillVm } from '@/features/dashboard/bookingChanges/types/BillViewModel.ts';

/**
 * Ekran rezerwacji (C1/C2): kafle osób, raty i wpłaty.
 *
 * Tryb wpływa na treść kafli (kwota rachunku kontra delta paczki), dlatego
 * `editing` jest argumentem mapowania, a nie decyzją komponentu.
 */
const useBookingBillView = (bookingId: string | undefined, editing = false) => {
  const billQuery = useBookingBill(bookingId);
  const draftQuery = useGetOpenDraft(bookingId);
  const previewQuery = useChangePreview(bookingId);

  const view: BookingBillVm | null = useMemo(() => {
    if (!billQuery.data) {
      return null;
    }
    return bookingBillMapper.toBookingView(
      billQuery.data,
      draftQuery.data?.items ?? [],
      previewQuery.preview,
      editing,
    );
  }, [billQuery.data, draftQuery.data, previewQuery.preview, editing]);

  return {
    view,
    isLoading:
      billQuery.isLoading || draftQuery.isLoading || previewQuery.isLoading,
    isError: billQuery.isError || draftQuery.isError,
  };
};

export default useBookingBillView;
